import React from 'react';
import { Input } from 'antd';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import PropTypes from 'prop-types';

const { TextArea: AntTextArea } = Input;

export const TextArea = ({ 
  label,
  error, 
  helperText,
  layout,
  labelCol,
  wrapperCol,
  required,
  ...props 
}) => {
  return (
    <InputWrapper
      label={label}
      error={error}
      helperText={helperText}
      required={required}
      layout={layout}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <AntTextArea 
        status={error ? 'error' : ''} 
        {...props} 
      />
    </InputWrapper>
  );
};

TextArea.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  labelCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  wrapperCol: PropTypes.shape({
    span: PropTypes.number,
    offset: PropTypes.number,
  }),
  required: PropTypes.bool,
};

export default TextArea; 